"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/styles");
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Chip = _interopRequireDefault(require("@mui/material/Chip"));
var _concatTokens = _interopRequireDefault(require("../services/concatTokens"));
var _theme = require("../theme");
var variantStyle = false;

/**
 * @param props
 * @returns {*}
 * @constructor
 */
var Chips = function Chips(props) {
  var classes = props.classes,
    chipData = props.chipData,
    _onDelete = props.onDelete,
    variant = props.variant,
    customStyle = props.customStyle,
    id = props.id,
    testid = props.testid;
  if (variant) {
    variantStyle = variant;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id || testid,
    className: "".concat(classes.chipBlock, " ").concat(customStyle)
  }, chipData.length > 0 && chipData.map(function (chip, i) {
    return /*#__PURE__*/_react["default"].createElement(_Chip["default"], {
      key: (0, _concatTokens["default"])(chip, i),
      label: chip,
      color: "primary",
      deleteIcon: /*#__PURE__*/_react["default"].createElement(_Close["default"], {
        className: classes.closeChipIcon
      }),
      variant: variant || 'default',
      onDelete: function onDelete() {
        return _onDelete(chip);
      },
      className: "".concat(classes.chip)
    });
  }));
};

/**
 * @param theme
 */
var styles = function styles(theme) {
  return {
    // Todo: Add global styles from UI library
    chipBlock: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexWrap: 'wrap'
    },
    closeChipIcon: {
      color: 'inherit',
      fontSize: '18px',
      '&:hover': {
        filter: 'brightness(75%)'
      }
    },
    chip: {
      color: variantStyle === 'outlined' ? _theme.colors.skyBlue : _theme.colors.surface,
      margin: '7.5px',
      marginLeft: '2.5px',
      marginRight: '2.5px',
      boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)'
    }
  };
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(Chips);